import AdminShell from './shell';

export * from './login';

export default AdminShell;
